import React, { ChangeEvent, Dispatch } from 'react'

import { connect } from 'react-redux'
import {
  IReduxAction,
  IReduxState,
  PredictionModel
} from '../../../utils/ReduxStore'

interface IDispatchProps {
  setPredictionModel: (model: PredictionModel) => void
}

interface IStateProps {
  predictionModel: PredictionModel
}

interface IProps extends IDispatchProps, IStateProps {}

class SettingsScreen extends React.Component<IProps> {
  public constructor(props: IProps) {
    super(props)

    this.changePredictionModel = this.changePredictionModel.bind(this)
  }

  protected changePredictionModel(event: ChangeEvent<HTMLInputElement>): void {
    this.props.setPredictionModel(event.currentTarget.value as PredictionModel)
  }

  public render(): JSX.Element {
    const { predictionModel } = this.props
    return (
      <React.Fragment>
        <h2>Prediction model</h2>
        <div className="form-check form-check-inline">
          <input
            name="predictionModel"
            type="radio"
            id="predictionModelRadio1"
            value="deterministic"
            checked={predictionModel === 'deterministic'}
            onChange={this.changePredictionModel}
          />
          <label className="form-check-label" htmlFor="predictionModelRadio1">
            Deterministic swing
            <small className="text-muted d-none d-sm-block">
              For each riding in a given area, apply the proportionate
              difference between a party&rsquo;s vote share in the area in the
              previous election and its predicted vote share in this election.
              Given identical poll inputs, this will lead to identical predicted
              outcomes.
            </small>
            <small className="text-muted d-block d-sm-none">
              Do not apply randomization to results.
            </small>
          </label>
        </div>
        <div className="form-check form-check-inline">
          <input
            name="predictionModel"
            type="radio"
            id="predictionModelRadio2"
            value="randomized"
            checked={predictionModel === 'randomized'}
            onChange={this.changePredictionModel}
          />
          <label className="form-check-label" htmlFor="predictionModelRadio2">
            Randomized swing
            <small className="text-muted d-none d-sm-block">
              Like the deterministic model, but additionally takes into account
              the variability of polls by randomly generating a statistically
              possible current vote share. This will lead to a variety of
              predicted outcomes even given identical poll numbers.
            </small>
            <small className="text-muted d-block d-sm-none">
              Add statistical randomization to results when changing poll
              values.
            </small>
          </label>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state: IReduxState): IStateProps => ({
  predictionModel: state.predictionModel
})

const mapDispatchToProps = (
  dispatch: Dispatch<IReduxAction>
): IDispatchProps => ({
  setPredictionModel: (predictionModel: PredictionModel): void => {
    dispatch({ type: 'SET_PREDICTION_MODEL', predictionModel })
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsScreen)
